export default {"src":"/_next/static/media/policy-training.3404524b.svg","height":861,"width":861,"blurWidth":0,"blurHeight":0};